var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgInfoAlert = function SvgInfoAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M15 23a8 8 0 110-16 8 8 0 010 16zm-1.615-3.924h3.239c.213 0 .386-.201.386-.448s-.173-.448-.386-.448l-.619-.11v-4c0-.041.004-.055.007-.07-.011.026-.036.058-.113.058h-2.514c-.213 0-.385.201-.385.448s.172.448.385.448l.62.116v3l-.62.11c-.213 0-.385.201-.385.448s.172.448.385.448zm.628-8.072v.941c-.002.021-.013.039-.013.06 0 .022.011.039.013.06v.939h.967c.011.001.021.007.033.007.011 0 .021-.006.033-.007h.967v-.938c.001-.021.012-.039.012-.061 0-.021-.011-.039-.012-.061v-.94h-.98c-.007 0-.013-.004-.02-.004-.007 0-.013.004-.02.004h-.98z"
  }))));
};
export default SvgInfoAlert;